import styled from 'styled-components';

export const ErrorContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 24px;
  background: #fff;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  color: #343a40;
  overflow-wrap: anywhere;

  > svg {
    flex-shrink: 0;
    color: #c92a2a;
  }

  h2 {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
  }

  p {
    margin: 8px 0 0;
    font-size: 14px;
    line-height: 22px;
    color: #495057;
  }
`;
